import {notification} from "antd";
import React, {useState} from "react";
import {DeleteIcon, EditIcon} from "../../../../assets/icons/sidebarIcons";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {DeleteForumService} from "../../../services/forum.service";
import ActionModal from "../../../components/common/modals/action-modal/ActionModal";
import {AiOutlineEye} from "react-icons/ai";

const TableForumComp = ({
                            Data,
                            setModalIsOpen,
                            setEditModalIsOpen,
                            setSelectedForum,
                            selectedForum,
                            renderContent,
                            setRenderContent,
                            setDetailModalIsOpen
                        }) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const [loader, setLoader] = useState(false);

    const HandleDelete = async () => {
        try {
            setLoader(true)
            let res = await DeleteForumService(Data?._id);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
            }
        } catch (error) {
        } finally {
            setRenderContent(!renderContent);
            setDeleteModal(false);
            setLoader(false)
        }
    };

    const handleSelectItem = () => {
        // if (selectedForum !== null || selectedForum !== "") {
        //   setSelectedForum(null);
        // } else {
        //   setSelectedForum(Data);
        // }
        setSelectedForum(Data);
        setEditModalIsOpen(true);
    };
    const handleSelectDetailItem = () => {
        // if (selectedForum !== null || selectedForum !== "") {
        //   setSelectedForum(null);
        // } else {
        //   setSelectedForum(Data);
        // }
        setSelectedForum(Data);
        setDetailModalIsOpen(true);
    };

    return (
        <>
            <div className="main_div_table_comp">
                <div className="inner_div_table_comp">
                    <table>
                        <tbody>
                        <tr>
                            <td className={'first'}>  <span>{Data?.month}</span></td>
                            <td className={'second'}>  <span className="para">{Data?.year}</span></td>
                            <td className={'third'}>
                                <div className="action_div">
                                    {Data?.isNextMonthRecord && Data?.isNextMonthRecord == true ? (
                                        <div className="add_btn" onClick={() => setModalIsOpen(true)}>
                                            Add
                                        </div>
                                    ) : (
                                        <div className="inner_div_action">
                                             <span onClick={handleSelectDetailItem}>
                                                 <AiOutlineEye />
                                             </span>
                                            <span onClick={handleSelectItem}>
                                              <EditIcon />
                                            </span>
                                            <span onClick={() => setDeleteModal(true)}>
                                              <DeleteIcon />
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    {/*<Row>*/}
                    {/*  <Col lg={8} xl={8} md={8} className="table_col_custom">*/}
                    {/*    <p>{Data?.month}</p>*/}
                    {/*  </Col>*/}
                    {/*  <Col lg={8} xl={4} md={4}>*/}
                    {/*    <p className="para">{Data?.year}</p>*/}
                    {/*  </Col>*/}
                    {/*  <Col lg={8} xl={8} md={8}>*/}
                    {/*   */}
                    {/*  </Col>*/}
                    {/*</Row>*/}
                </div>
            </div>

            <ActionModal
                show={deleteModal}
                close={setDeleteModal}
                modalHeading={"Delete Forum"}
                modalText={"Are you sure you want to delete this progress query?"}
                cancelBTnText={"Cancel"}
                actionBTnText={"Delete"}
                // loader={loader}
                actionBtnFunc={() => {
                    HandleDelete()
                }}
                loader={loader}
            />

        </>
    );
};

export default TableForumComp;
